import React from 'react';
import { observer } from "mobx-react";
import { cartInstance } from 'ReactApp/Ddd/Aggregates/Cart';
import {ShowableProductCard, showableProductCardInstance} from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import { AddToWishListV1 } from 'ReactApp/Components/AddToWishListV1/AddToWishListV1';
import { AddToCompareV1 } from 'ReactApp/Components/AddToCompareV1/AddToCompareV1';
import { ShareV1 } from 'ReactApp/Components/ShareV1/ShareV1';
import { BuyBtnV1 } from 'ReactApp/Components/BuyBtnV1/BuyBtnV1';

type BuyBlockV1Props = {
    productCard: ShowableProductCard
}

const BuyBlockV1 = observer((props: BuyBlockV1Props) => {

    if (props.productCard.salePrice === null) {
        return <></>;
    }

    return (
        <>
            <div className="buy-block-v1" id="buy-block-wrap">
            
                <div className="buy-block-v1__buy-container">
            
                    <div className="buy-block-v1__buy-container-row">

                        <div className="buy-block-v1__column buy-block-v1__equal buy-block-v1__action-buttons">

                            <AddToWishListV1 {...{
                                productCard: showableProductCardInstance
                            }} />

                            <AddToCompareV1 {...{
                                productCard: showableProductCardInstance
                            }} />

                           <ShareV1 {...{
                               productCard: showableProductCardInstance
                           }}/>

                        </div>

                        <div className="buy-block-v1__column">

                            <BuyBtnV1 {...{
                                productCard: showableProductCardInstance
                            }} />
            
                        </div>
            
                    </div>
            
                    <a 
                        className="
                            button-v1 
                            buy-block-v1__buy-one-click
                            more__link
                            js-open-popup
                        " 
                        href="#"
                        data-popup="js-one-click-popup"
                        data-popup-config={JSON.stringify(props.productCard.buyInClickModalConfig)}
                        >
                            Купить в 1 клик
                    </a>
            
                </div>
            
            </div>
        </>
    );

})

export default BuyBlockV1;